import React from "react";
import { Box, Stack, Dialog, DialogActions, DialogContent, DialogTitle, Tab } from "@mui/material";
import { Close } from "@mui/icons-material";
import CloseButton from "../../../components/commonComponents/Buttons/CloseButton";
import { useDispatch, useSelector } from "react-redux";
import CommonConfirmation from "../../../components/commonComponents/CommonConfirmation";
import PropTypes from "prop-types";
import AnalyticsProductView from "./Products/AnalyticsProductView";
import { StyledMainBox, StyledNestedTabs } from "../../../components/commonComponents/StyledComponents/styled";
import ListingCheckUi from "../ListingCheck/ListingCheckUi";
import { checkUserDetailsFromCookie, checkUserPermissions } from "../../../api_calls/userManagement";
import ListingCheckView from "./Products/ListingCheckView";

// to load tab content
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const NewProductModal = ({ open, size, closeModal, campaignRecord }) => {
  const currentStateData = useSelector((state) => state.userSelections);
  const dispatchAction = useDispatch();
  const [tabValue, setTabValue] = React.useState(0);
  const permissions = checkUserPermissions();
  const checkUserDetails = checkUserDetailsFromCookie();
  const userType = checkUserDetails.user_detail.user_type;
  let deactivatedSections = checkUserDetails.success === true ? checkUserDetails.user_detail.deactivated_sections : [];
  //---- tabs won't show if there's no analytics product added, listing check section is deactivated or the current user doesn't have permission to access it ------
  const showTabs = typeof currentStateData.created_adlevels !== "undefined" && currentStateData.created_adlevels.length > 0 && permissions.allowed_access.listing_check_can_edit === true && (userType === "cyreen" || !deactivatedSections.includes("listingCheck"));

  const dataContainerRef = React.useRef(null);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  let tabs = [
    {
      label: "Analytics Products",
      // icon: <Visibility />,
      unique_key: "analytics_product_section",
      content: <AnalyticsProductView
        open={open}
        size={size}
        closeModal={closeModal}
        campaignRecord={campaignRecord}
        containerRef={dataContainerRef}
      />,
    },
    {
      label: "Listing Check",
      // icon: <Visibility />,
      unique_key: "listing_check_sections",
      content: (<ListingCheckView
        open={open}
        size={size}
        closeModal={closeModal}
        campaignRecord={campaignRecord}
        containerRef={dataContainerRef}
      />),
    },
  ];

  return (
    <Dialog
      open={open}
      onClose={(e) => {
        e.preventDefault();
      }}
      fullWidth={true}
      maxWidth={"xl"}
    >
      <DialogTitle> Manage your analytics products</DialogTitle>
      {/* ---- tabs won't show if there's no analytics product added, listing check section is deactivated or the current user doesn't have permission to access it ------ */}
      <DialogContent ref={dataContainerRef}>
        {
          showTabs === true ? (<>
            <StyledNestedTabs value={tabValue} onChange={handleChange} aria-label="analytics product sections" textColor={"#F04B55"}>
              {tabs.map((tabDetail) => {
                return <Tab
                  key={tabDetail.unique_key}
                  aria-label={tabDetail.label}
                  label={tabDetail.label}
                  sx={{ width: "100%", maxWidth: "400px" }}
                  {...a11yProps(0)}
                />;
              })}
            </StyledNestedTabs>
            {/* ============== tab contents =========== */}
            {tabs.map((tabDetail, index) => {
              return (
                <CustomTabPanel value={tabValue} index={index}>
                  {tabDetail.content}
                </CustomTabPanel>
              );
            })}
          </>) : (
            <AnalyticsProductView
              open={open}
              size={size}
              closeModal={closeModal}
              campaignRecord={campaignRecord}
            />
          )
        }
      </DialogContent>
    </Dialog>
  );
};

export default NewProductModal;
